import { mainPath } from './config/serverConfig';

import RestMethods from './config/restMethods';

class CountryResources {
  constructor() {
    this.restMethods = new RestMethods();
  }

  getCountries(locale) {
      return this.restMethods.get(`${mainPath}/countries?locale=${locale}&legacy=1`);
  }
}

export default CountryResources;
